import React from 'react';
import Modal from '../../component/Inc/Modal';

function PopFeeManageCard(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} popSize="s" type="">
      <div className="pop_tit line">카드사 별 수수료 관리</div>
      <div className="content_container pop_fee_manage_card">
        <div className="com_board_list__scroll">
          <table className="com_board_list">
            <thead>
              <tr>
                <th>카드사</th>
                <th>수수료(%)</th>
                <th>최근 변경일</th>
              </tr>
            </thead>
            <tbody>
              <tr className='selected'>
                <td>국민</td>
                <td>0.2</td>
                <td>
                  김관리 103
                  <br />
                  2023, 05, 20
                </td>
              </tr>
              <tr>
                <td>국민</td>
                <td>0.2</td>
                <td>
                  김관리 103
                  <br />
                  2023, 05, 20
                </td>
              </tr>
              <tr>
                <td>국민</td>
                <td>0.2</td>
                <td>
                  김관리 103
                  <br />
                  2023, 05, 20
                </td>
              </tr>
              <tr>
                <td>국민</td>
                <td>0.2</td>
                <td>
                  김관리 103
                  <br />
                  2023, 05, 20
                </td>
              </tr>
              <tr>
                <td>국민</td>
                <td>0.2</td>
                <td>
                  김관리 103
                  <br />
                  2023, 05, 20
                </td>
              </tr>
              <tr>
                <td>국민</td>
                <td>0.2</td>
                <td>
                  김관리 103
                  <br />
                  2023, 05, 20
                </td>
              </tr>
              <tr>
                <td>국민</td>
                <td>0.2</td>
                <td>
                  김관리 103
                  <br />
                  2023, 05, 20
                </td>
              </tr>
              <tr>
                <td>국민</td>
                <td>0.2</td>
                <td>
                  김관리 103
                  <br />
                  2023, 05, 20
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ul className="com_input_sec">
          <li className="tit_field">카드사 명 입력</li>
          <li className="input_field">
            <input type="text" className="input" />
          </li>
          <li className="tit_field">수수료(%)</li>
          <li className="input_field">
            <input type="text" className="input" />
          </li>
        </ul>
      </div>
      {/*<div className="btn_container">
        <button className="com_btn gray xs">삭제</button>
        <button className="com_btn orange xs">저장</button>
      </div>*/}
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopFeeManageCard;
